import React, { Component } from 'react';
import { ThemeProvider } from 'styled-components';
import { func, bool, string, array } from 'prop-types';
import { Switch, Redirect, Route } from 'react-router-dom';
import './injectGlobalStyles';
import theme from '../../config/theme';
import Spinner from '../../components/Spinner';
import ErrorPopup from '../../components/ErrorPopup';
import AppLoader from './styles';
import Home from '../../views/Home';
import Member from '../../views/Member';
import Apartment from '../../views/Apartment';
import SwapReason from '../../views/SwapReason';
import SwapDetails from '../../views/SwapDetails';
import Upload from '../../views/Upload';
import Sign from '../../features/Sign';
import LBControl from '../../views/LBControl';
import LandlordControl from '../../views/LandlordControl';
import PageNotFound from '../../views/NotFound';
import DefaultLayout from '../../features/DefaultLayout';
import ApplicationPicker from '../ApplicationPicker';
import NotificationBar from '../../features/NotificationBar';
import { getRefreshToken, init } from '../../services/initiation';

class App extends Component {
  static propTypes = {
    applicantStarted: bool,
    cognitoLoginRefreshToken: func.isRequired,
    authenticated: bool.isRequired,
    configured: bool.isRequired,
    ready: bool.isRequired,
    setUpApp: func.isRequired,
    LBStatus: string,
    signStatus: string,
    pickableApplications: array, // eslint-disable-line
    showApplicationPicker: bool.isRequired,
    pickApplication: func.isRequired,
    shouldShowNotificationBar: bool.isRequired,
    setLastActiveDate: func.isRequired,
  };

  static defaultProps = {
    applicantStarted: false,
    LBStatus: null,
    signStatus: null,
    pickableApplications: null,
  };

  async componentDidMount() {
    window.isDev = process.env.NODE_ENV === 'development';

    await init();

    this.props.setUpApp();

    await this.props.cognitoLoginRefreshToken({
      refreshToken: getRefreshToken(),
    });
  }

  componentDidUpdate() {
    this.props.setLastActiveDate();
  }

  routes = () => (
    <Switch>
      <Route
        exact
        path="/"
        render={() => {
          if (this.props.applicantStarted) {
            return <Redirect to="/bytespart" />;
          }
          return <DefaultLayout path="/" component={Home} />;
        }}
      />

      {!this.props.applicantStarted && <Redirect to="/" />}

      <DefaultLayout path="/bytespart/:index?" component={Member} />
      <DefaultLayout path="/lagenhet/:index?" component={Apartment} />
      <DefaultLayout path="/skal-till-bytet" component={SwapReason} />
      <DefaultLayout path="/bytesdetaljer" component={SwapDetails} />
      <DefaultLayout path="/ladda-upp/minuc" component={Upload} />
      <DefaultLayout path="/ladda-upp/personbevis" component={Upload} />
      <DefaultLayout path="/ladda-upp/inkomstbevis" component={Upload} />
      <DefaultLayout path="/ladda-upp/hyresavtal" component={Upload} />
      <DefaultLayout path="/ladda-upp/hyresbevis" component={Upload} />
      <Route
        path={window.isBytesansokanSe ? '/lagenhetsbyte-granskar' : '/granskar'}
        render={() => {
          if (this.props.LBStatus !== null) {
            return (
              <DefaultLayout
                path={
                  window.isBytesansokanSe
                    ? '/lagenhetsbyte-granskar'
                    : '/granskar'
                }
                component={LBControl}
              />
            );
          }
          return <Redirect to="/bytespart" />;
        }}
      />
      <Route
        path="/signering"
        render={() => {
          if (this.props.LBStatus === 'APPROVED') {
            return <DefaultLayout path="/signering" component={Sign} />;
          }
          return (
            <Redirect
              to={
                window.isBytesansokanSe
                  ? '/lagenhetsbyte-granskar'
                  : '/granskar'
              }
            />
          );
        }}
      />
      <Route
        path="/hyresvard-hanterar"
        render={() => {
          if (this.props.signStatus === 'APPROVED') {
            return (
              <DefaultLayout
                path="/hyresvard-hanterar"
                component={LandlordControl}
              />
            );
          }
          return <Redirect to="/signering" />;
        }}
      />
      <DefaultLayout component={PageNotFound} />
    </Switch>
  );

  render() {
    return (
      <ThemeProvider theme={theme}>
        <React.Fragment>
          {this.props.shouldShowNotificationBar && <NotificationBar />}
          {(!this.props.ready ||
            !this.props.configured ||
            !this.props.authenticated) && (
            <AppLoader>
              <Spinner />
              <p>Laddar Bytesansökan...</p>
            </AppLoader>
          )}
          {this.props.showApplicationPicker && (
            <ApplicationPicker
              applications={this.props.pickableApplications}
              pickApplication={this.props.pickApplication}
            />
          )}
          {this.props.ready &&
            this.props.configured &&
            this.props.authenticated &&
            this.routes()}
          <ErrorPopup />
        </React.Fragment>
      </ThemeProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App/App.js